import { initializeApp } from "firebase/app";
import type { FirebaseApp } from "firebase/app";
import { useEffect, useRef } from "react";

export function useFirebaseApp() {
  const firebaseApp = useRef<FirebaseApp>();

  function init() {
    if (!firebaseConfigs[process.env.NEXT_PUBLIC_FIREBASE_CONFIG as string])
      return;
    const _app = initializeApp(
      firebaseConfigs[process.env.NEXT_PUBLIC_FIREBASE_CONFIG as string],
    );

    firebaseApp.current = _app;
  }

  useEffect(() => {
    init();
  }, []);

  return { app: firebaseApp.current };
}

const firebaseConfigs: Record<string, any> = {
  development: {
    apiKey: "AIzaSyATH81P0PSyXrpnV0sqji7csRGbmiKt8Wc",
    authDomain: "kunduz-staging.firebaseapp.com",
    projectId: "kunduz-staging",
    storageBucket: "kunduz-staging.appspot.com",
    messagingSenderId: "883895962695",
    appId: "1:883895962695:web:ad5a3394e64ccbab64f562",
    measurementId: "G-RJC7JMFL7M",
  },
  production: {
    apiKey: "AIzaSyC3_1946FwtHuNzhDgVFKvBMkKjaOONuEk",
    authDomain: "kunduz-dab75.firebaseapp.com",
    databaseURL: "https://kunduz-dab75.firebaseio.com",
    projectId: "kunduz-dab75",
    storageBucket: "kunduz-dab75.appspot.com",
    messagingSenderId: "429238372725",
    appId: "1:429238372725:web:f044f114d00d1404d2eb3c",
    measurementId: "G-3M113D4CBP",
  },
};
